// Mueve el ancla única de Orbe entre header (desktop) y drawer (mobile)
const MOBILE_BP = 750;

function getAnchor() {
  return document.getElementById("custom__md-footer-selector-block");
}

function getHeaderTarget() {
  // Contenedor de la columna derecha top
  return (
    document.querySelector('[data-testid="header-top-right"]') || document.body
  );
}

function getDrawerTarget() {
  return document.querySelector("[data-orbe-drawer-anchor]");
}

function isMobile() {
  return window.innerWidth < MOBILE_BP;
}

function relocate() {
  const anchor = getAnchor();
  if (!anchor) return;

  if (isMobile() && document.querySelector(".menu-open")) {
    const drawerTarget = getDrawerTarget();
    if (drawerTarget && anchor.parentNode !== drawerTarget) {
      drawerTarget.appendChild(anchor);
    }
    // Fuerza mostrar en mobile dentro del drawer
    anchor.style.display = "block";
  } else {
    const headerTarget = getHeaderTarget();
    if (headerTarget && anchor.parentNode !== headerTarget) {
      headerTarget.appendChild(anchor);
    }
    // Resetea estilo inline para que gobierne CSS por breakpoint
    anchor.style.display = "";
  }
}

const debounce = (fn, wait = 120) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
};

function init() {
  // Reintenta varias veces al inicio por si el ancla o el drawer tardan en existir
  let attempts = 0;
  const tryRelocate = () => {
    relocate();
    if (++attempts < 15) setTimeout(tryRelocate, 120);
  };
  tryRelocate();

  window.addEventListener("resize", debounce(relocate, 150));
  document.addEventListener("click", (e) => {
    if (
      e.target.closest('[on\\:click*="header-drawer"]') ||
      e.target.closest(".menu-drawer__close-button") ||
      e.target.closest('[on\\:click="/toggle"]') ||
      e.target.closest('[on\\:click="/close"]') ||
      e.target.closest('[on\\:click="header-drawer/back"]')
    ) {
      setTimeout(relocate, 160);
    }
  });

  // Observa cambios de atributos para realojar si cambia el estado del drawer
  const observer = new MutationObserver(debounce(relocate, 60));
  observer.observe(document.documentElement, {
    attributes: true,
    subtree: true,
    attributeFilter: ["class", "open"],
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
